import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ImportRoutingModule } from './import-routing.module';
import { ImportComponent } from './import.component';

@NgModule({
  imports: [CommonModule, IonicModule, ImportRoutingModule],
  declarations: [ImportComponent]
})
export class ImportModule { }
